module.exports = __webpack_public_path__ + "static/logos/surf-forecast__logo--icon-6cac8d52435b7e2a10880e20e104dac9.svg";